import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import PageHero from '../components/ui/PageHero';
import './About.css';

const teamValues = [
  {
    icon: '🔍',
    title: 'Uafhængighed',
    desc: 'Vores redaktionelle vurderinger er aldrig til salg. Vi anmelder casinoer baseret på egne kriterier og objektive tests – ikke på kommercielle aftaler.'
  },
  {
    icon: '🇩🇰',
    title: 'Dansk fokus',
    desc: 'Vi skriver for og om det danske spillemarked. Vi kender de lokale regler, de relevante udbydere og den lovgivning, der gælder for danske spillere.'
  },
  {
    icon: '🛡️',
    title: 'Spillersikkerhed',
    desc: 'Ansvarligt spil er ikke et eftertanke – det er en kerneværdi. Vi fremhæver altid spillerbeskyttelsesredskaber i vores anmeldelser og guider.'
  },
  {
    icon: '📊',
    title: 'Transparens',
    desc: 'Vi oplyser tydeligt om vores affiliate-relationer og forklarer, hvordan vi finansierer vores arbejde, uden at det kompromitterer vores integritet.'
  },
];

export default function About() {
  return (
    <>
      <Helmet>
        <title>Om Os – TopCasinoDansk</title>
        <meta name="description" content="Lær mere om TopCasinoDansk – vores mission, værdier og den redaktionelle tilgang bag Danmarks uafhængige casinoguide." />
      </Helmet>

      <PageHero
        title="Om TopCasinoDansk"
        subtitle="Vi er en uafhængig redaktion dedikeret til at hjælpe danske spillere med at navigere sikkert og informeret på det regulerede casinomarked."
        breadcrumb={<><Link to="/">Forside</Link> › Om Os</>}
      />

      <section className="about-mission section">
        <div className="container">
          <div className="about-mission-grid">
            <div className="about-mission-content">
              <div className="divider"></div>
              <h2>Vores mission</h2>
              <p>
                TopCasinoDansk blev grundlagt med ét formål: at skabe den mest pålidelige, uafhængige og
                dansksproede ressource for spillere, der ønsker at forstå det regulerede online casinomarked i Danmark.
              </p>
              <p>
                Vi er ikke en spiludbyder. Vi accepterer ingen indskud, vi udbyder ingen spil, og vi har ingen
                kommercielle aftaler med casinoerne, der kan påvirke vores redaktionelle vurderinger. Vores arbejde
                finansieres via affiliate-kommissioner – dette oplyser vi åbent og transparent.
              </p>
              <p>
                Hvad vi tilbyder, er grundig research, tydelig sammenligning og ærlig vejledning – skrevet på
                naturligt dansk til det danske marked.
              </p>
            </div>

            <div className="about-mission-aside">
              <div className="about-quick-facts">
                <h4>Om platformen</h4>
                <dl className="quick-facts-list">
                  <div className="quick-fact">
                    <dt>Type</dt>
                    <dd>Uafhængig guide & sammenligningsportal</dd>
                  </div>
                  <div className="quick-fact">
                    <dt>Målgruppe</dt>
                    <dd>Voksne danske spillere (18+)</dd>
                  </div>
                  <div className="quick-fact">
                    <dt>Sprog</dt>
                    <dd>Dansk</dd>
                  </div>
                  <div className="quick-fact">
                    <dt>Marked</dt>
                    <dd>Danmark (reguleret af Spillemyndigheden)</dd>
                  </div>
                  <div className="quick-fact">
                    <dt>Affiliate</dt>
                    <dd>Ja – oplyst tydeligt</dd>
                  </div>
                  <div className="quick-fact">
                    <dt>Redaktionel uafhængighed</dt>
                    <dd>Ubetinget</dd>
                  </div>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="about-values section bg-sand">
        <div className="container">
          <div className="divider divider-center"></div>
          <h2 style={{ textAlign: 'center', marginBottom: '0.75rem' }}>Vores kerneværdier</h2>
          <p style={{ textAlign: 'center', color: 'var(--color-text-secondary)', maxWidth: 560, margin: '0 auto 3rem' }}>
            Disse principper er grundlaget for alt vi gør – fra vores anmeldelser til den måde, vi omtaler ansvarligt spil på.
          </p>
          <div className="values-grid">
            {teamValues.map((v, i) => (
              <div key={i} className="value-card">
                <div className="value-icon">{v.icon}</div>
                <h4>{v.title}</h4>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How we work */}
      <section className="about-how section">
        <div className="container about-how-grid">
          <div>
            <div className="divider"></div>
            <h2>Hvad vi gør – og hvad vi ikke gør</h2>

            <div className="about-do-grid">
              <div className="about-do-col about-do-yes">
                <h5>Det gør vi ✓</h5>
                <ul>
                  <li>Anmelder licenserede casinoer selvstændigt</li>
                  <li>Tester betalingsprocesser og udbetalingstider</li>
                  <li>Fremhæver ansvarlige spilredskaber</li>
                  <li>Oplyser om ROFUS og StopSpillet</li>
                  <li>Opdaterer vores indhold løbende</li>
                  <li>Deler affiliate-relationer åbent</li>
                  <li>Skriver kun om Spillemyndigheden-godkendte casinoer</li>
                </ul>
              </div>
              <div className="about-do-col about-do-no">
                <h5>Det gør vi ikke ✗</h5>
                <ul>
                  <li>Accepterer indskud eller udbyder spil</li>
                  <li>Anbefaler uautoriserede casinoer</li>
                  <li>Sælger redaktionelle anmeldelser</li>
                  <li>Lader kommercielle aftaler styre vurderinger</li>
                  <li>Retter os mod mindreårige</li>
                  <li>Lover gevinster eller skjuler risici</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="about-cta-block">
            <h4>Vil du vide mere?</h4>
            <p>Læs om vores detaljerede anmeldelsesmetode, eller kontakt os direkte, hvis du har spørgsmål om vores redaktionelle processer.</p>
            <div className="about-cta-links">
              <Link to="/vores-metode" className="btn btn-primary">Vores anmeldelsesmetode</Link>
              <Link to="/kontakt" className="btn btn-outline">Kontakt os</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Disclaimer */}
      <section className="about-disclaimer section-sm bg-sand">
        <div className="container">
          <div className="disclaimer-box">
            <span className="disclaimer-icon">⚠️</span>
            <div>
              <h5>Affiliate-oplysning</h5>
              <p>
                TopCasinoDansk indeholder affiliate-links. Når du besøger et casino via vores links og registrerer en konto,
                kan vi modtage en kommission fra spiludbyderen. Kommissioner modtages <em>ikke</em> på forhånd og er aldrig
                forbundet med krav om specifikke vurderinger. Vores redaktionelle uafhængighed er ubetinget.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
